// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2dee2e6f","453":"e5108a4e","667":"68914ff9"}[chunkId] + ".chunk.js";
};